import React from 'react';
import { Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';
import { BarChart2, Sparkles } from 'lucide-react';
import MetaDashboard from './MetaDashboard';
import CreativosView from './CreativosView';

const MarketingLayout: React.FC = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const NavLink = ({ to, label, icon: Icon }: { to: string; label: string; icon: any }) => {
    const active = currentPath.startsWith(`/marketing${to}`);
    return (
      <Link
        to={`/marketing${to}`}
        className={`px-3 sm:px-4 py-2 text-xs sm:text-sm font-semibold transition-all rounded-full flex items-center gap-2 whitespace-nowrap ${
          active
            ? 'bg-primary/90 text-white shadow-sm'
            : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-gray-700'
        }`}
      >
        <Icon size={15} />
        <span className="hidden sm:inline">{label}</span>
      </Link>
    );
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-1 px-2 sm:px-0 overflow-x-auto">
        <NavLink to="/campanhas" label="Campanhas" icon={BarChart2} />
        <NavLink to="/criativos" label="Criativos" icon={Sparkles} />
      </div>

      <Routes>
        <Route index element={<Navigate to="/marketing/campanhas" replace />} />
        <Route path="campanhas" element={<MetaDashboard />} />
        <Route path="criativos" element={<CreativosView />} />
      </Routes>
    </div>
  );
};

export default MarketingLayout;
